import { Dispatch } from 'redux';

import { getServices, Service } from '../../services/buildings';
import { captureException } from '../../services/sentry';
import { getUnit, Unit } from '../../services/units';
import { CustomError } from '../../utils/errors';
import {
  ActionInterface,
  dispatcher,
  generateActions,
} from '../../utils/redux';

export enum UnitActions {
  getUnitStart = '[UNIT]:GET_UNIT:START',
  getUnitSuccess = '[UNIT]:GET_UNIT:SUCCESS',
  getUnitError = '[UNIT]:GET_UNIT:ERROR',
  getServicesStart = '[UNIT]:GET_SERVICES:START',
  getServicesSuccess = '[UNIT]:GET_SERVICES:SUCCESS',
  getServicesError = '[UNIT]:GET_SERVICES:ERROR',
}

const unitActionsMap: {
  [key: string]: UnitActions;
} = UnitActions as any;

export function DoGetUnit(id: number) {
  const [start, success, error] = generateActions<UnitActions, Unit>(
    'getUnit',
    unitActionsMap
  );
  return async (
    d: Dispatch<ActionInterface<UnitActions>>
  ): Promise<Unit | CustomError> => {
    const dispatch = dispatcher(d);
    dispatch(start)();
    try {
      const response = await getUnit(id);
      dispatch(success)(response);
      return response;
    } catch (e) {
      const errors = captureException(e);
      dispatch(error)(errors.toString());
      return errors;
    }
  };
}

export function DoGetUnitServices(id: number) {
  const [start, success, error] = generateActions<UnitActions, Service[]>(
    'getServices',
    unitActionsMap
  );
  return async (d: Dispatch<ActionInterface<UnitActions>>) => {
    const dispatch = dispatcher(d);
    dispatch(start)();
    try {
      const response = await getServices(id);
      return dispatch(success)(response);
    } catch (e) {
      const errors = captureException(e);
      return dispatch(error)(errors.toString());
    }
  };
}
